import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d6d8b73"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick", "onMouseover"]
const _hoisted_2 = { class: "info" }
const _hoisted_3 = {
  key: 1,
  class: "info-tooltip"
}
const _hoisted_4 = ["hidden"]
const _hoisted_5 = { class: "range-slider" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0%", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "100%", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "info" }
const _hoisted_11 = {
  key: 0,
  class: "info-tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ib_icons = _resolveComponent("ib-icons")!

  return (_openBlock(), _createElementBlock("div", {
    id: "heatmaps-controls",
    onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = true)),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.active = false)),
    class: _normalizeClass({ active: _ctx.active })
  }, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heatmapsConfig, (heatmap) => {
        return (_openBlock(), _createElementBlock("li", {
          key: heatmap.classification,
          class: _normalizeClass(_ctx.getCssClass(heatmap)),
          onClick: ($event: any) => (_ctx.toggleHeatmap(heatmap)),
          onMouseover: ($event: any) => (_ctx.currentlyHoveredHeatmap = heatmap.classification),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentlyHoveredHeatmap = ''))
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isDescriptionExist(heatmap.classification))
              ? (_openBlock(), _createBlock(_component_ib_icons, {
                  key: 0,
                  class: "info-circle",
                  icon: 'information',
                  color: _ctx.getInfoIconColor(heatmap),
                  size: 16
                }, null, 8, ["color"]))
              : _createCommentVNode("", true),
            (_ctx.isDescriptionExist(heatmap.classification))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.t(
                `config.heatmap.${_ctx.state.currentSlide.tissueType}.${this.state.currentSlide.stain}.${heatmap.classification}.description`
              )), 1))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.t(
            `config.heatmap.${_ctx.state.currentSlide.tissueType}.${this.state.currentSlide.stain}.${heatmap.classification}.displayText`
          )), 1)
        ], 42, _hoisted_1))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: "opacity-controls",
      hidden: !_ctx.heatmapsConfig.length
    }, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.t("heatmaps.opacity")) + ":", 1),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.heatmapsOpacity) = $event)),
          type: "range",
          min: "0.1",
          max: "1",
          step: "0.01"
        }, null, 512), [
          [_vModelText, _ctx.heatmapsOpacity]
        ]),
        _hoisted_7
      ])
    ], 8, _hoisted_4),
    (_ctx.heatmapsConfig.length)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(_ctx.t("heatmaps.heatmaps")), 1))
      : (_openBlock(), _createElementBlock("h4", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.t("heatmaps.no_heatmaps")) + " ", 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ib_icons, {
              class: "info-circle",
              icon: 'information',
              color: 'primary',
              size: 16
            }),
            (!_ctx.heatmapsConfig.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.t("heatmaps.no_heatmaps_configured", {
              tissue: _ctx.state.currentSlide.tissueType,
              stain: _ctx.state.currentSlide.stain,
            })), 1))
              : _createCommentVNode("", true)
          ])
        ]))
  ], 34))
}